// adapted from:
// https://stackoverflow.com/a/36862446/2167004
// https://stackoverflow.com/a/8876069/2167004

import { useState, useEffect } from 'react';
// This decimal is multiplied against the viewport width to boost the left
// padding value for maplibre's cameraForBounds method
import { SIDE_PANEL_PADDING_BOOST_DECIMAL } from '#/shared/constants';

const getViewportDimension = (height = true) =>
  typeof window !== 'undefined'
    ? Math.max(
        document.documentElement[height ? 'clientHeight' : 'clientWidth'] || 0,
        window[height ? 'innerHeight' : 'innerWidth'] || 0
      )
    : 0;

export const getViewportHeight = () => getViewportDimension();
export const getViewportWidth = () => getViewportDimension(false);

const useViewportDimensions = contentPanelRef => {
  const [dimensions, setDimensions] = useState({
    mapLeftOffset: 0,
    viewportHeight: getViewportHeight(),
    viewportWidth: getViewportWidth(),
  });

  useEffect(() => {
    const handleResize = () => {
      const newViewportWidth = getViewportWidth();
      const newViewportHeight = getViewportHeight();
      let leftOffset = 0;

      if (contentPanelRef?.current) {
        const computedStyle = window?.getComputedStyle(contentPanelRef.current);
        // Get the width of the content panel, defaulting to 0 if undefined
        const contentPanelWidth =
          typeof contentPanelRef?.current?.offsetWidth === 'number'
            ? contentPanelRef?.current?.offsetWidth
            : 0;
        // Calculate the total offset by combining:
        // 1. The content panel's width
        // 2. The panel's CSS left position
        // 3. Additional padding that scales with viewport width
        // leftOffset = contentPanelWidth + leftPixels;
        leftOffset =
          contentPanelWidth +
          parseFloat(computedStyle.left) +
          newViewportWidth * SIDE_PANEL_PADDING_BOOST_DECIMAL;
      }

      setDimensions({
        mapLeftOffset: leftOffset,
        viewportHeight: newViewportHeight,
        viewportWidth: newViewportWidth,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [contentPanelRef]);

  return dimensions;
};

export default useViewportDimensions;
